import $ from 'jquery'

// get user, account, toolkit account, license
export default function reloginCheck(duration, settings) {
  var param = $.param(settings)
  return $.ajax(`${process.env.VUE_APP_TOOLKIT_URL}/relogin_check/${duration}?${param}`, {
    type: 'get',
    dataType: 'json',
    xhrFields: {withCredentials: true}
  })
}
